export enum Permission {
  User = 0,
  Admin = 1
}

export type Login = {
  id: number;
  email: string;
  lastLogin: string;
  permission: number;
  isSuperAdmin: boolean;
}
